<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: { type: [Number, String], default: 0 },
});

const normalizedCount = computed(() => {
  const count = Number(props.count);
  return Number.isFinite(count) && count > 0 ? count : 0;
});

const displayCount = computed(() => {
  const count = normalizedCount.value;
  if (count < 1000) return String(count);
  if (count < 10000) {
    return `${(Math.floor(count / 100) / 10).toString().replace('.0', '')}k`;
  }
  if (count < 1000000) return `${Math.floor(count / 1000)}k`;
  return `${Math.floor(count / 1000000)}M`;
});
</script>

<template>
  <span
    v-if="normalizedCount > 0"
    data-test-id="sidebar-unread-badge"
    :title="String(normalizedCount)"
    class="inline-grid h-5 min-w-5 max-w-8 place-items-center rounded-full bg-n-slate-4 px-1 text-xxs font-medium leading-3 text-n-slate-12 dark:bg-n-slate-5 flex-shrink-0 tabular-nums"
  >
    {{ displayCount }}
  </span>
  <span v-else class="hidden" />
</template>
